<template>
  <sb-modal
    :active="showModal" :escape-trigger="true" :click-outside-trigger="false"
    class="extra-fee-modal-size" @close="rejectFee"
  >
    <h1 class="setmiddle feeModalTitle" data-testid="extraFeeModalTitle">
      <b>Are you sure?</b>
    </h1>
    <div class="feeModalText">
      <sb-checkbox v-model="feeAcceptedChecked">
        <p>
          By requesting to stow inventory outside the <b>{{ hubSelected }}</b> region, you agree to accept additional fees.
        </p>
        <p v-if="!isPoweredBySubAccountUser">
          To get a detailed breakdown of the per-unit pricing,
          <help-center-link link-key="createWro/nonIppSendDirectFees">
            click here
          </help-center-link>. If you have any questions or need further clarification, feel free to reach out to our dedicated support team at <a href="mailto:support@shipbob.com">support@shipbob.com</a>.
        </p>
      </sb-checkbox>
    </div>
    <div class="setmiddle">
      <sb-button
        variation="primary" :disabled="!feeAcceptedChecked" data-testid="acceptFeeButton" @click="acceptFee"
      >
        Yes, I accept
      </sb-button>
    </div>
    <div class="feeModalCancel setmiddle">
      <sb-button variation="tertiary" size="small" data-testid="rejectFeeButton" @click="rejectFee">
        Cancel
      </sb-button>
    </div>
  </sb-modal>
</template>

<script>

export default {
  name: 'ConfirmExtraFeeModal',
  inject: ['isPoweredBySubAccountUser'],
  props: { showModal: Boolean, hubSelected: { type: String, default: '' } },
  data: () => ({
    feeAcceptedChecked: false
  }),
  methods: {
    rejectFee () {
      this.$emit('feeRejected')
      this.feeAcceptedChecked = false
    },
    acceptFee () {
      this.$emit('feeAccepted')
      this.feeAcceptedChecked = false
    }
  }
}
</script>

<style scoped lang='scss'>
.setmiddle {
  text-align: center;
  width: 100%;
}

.feeModalTitle {
  margin-bottom: 1em;
}

.feeModalText {
  margin-bottom: 2em;
}

.feeModalCancel {
  margin-top: 1em;
}

.extra-fee-modal-size {
  padding-left: 30%;
  padding-right: 30%;
}
</style>
